import React from 'react';

export const ChargePoint = ({ w, h, colour, cpId, l1, l2, l3, car, lance }) => {
  // const green = '#0ed626';
  const green = '#50ee18';
  const blue = '#008fff';
  const red = '#de4b47';
  const grey = '#777777';
  const orange = '#ffa500';

  const rgb =
    colour === 'green'
      ? green
      : colour === 'blue'
      ? blue
      : colour === 'grey'
      ? grey
      : colour === 'orange'
      ? orange
      : red;

  return (
    <React.Fragment>
      <svg
        xmlnsosb="http://www.openswatchbook.org/uri/2009/osb"
        xmlnsdc="http://purl.org/dc/elements/1.1/"
        xmlnscc="http://creativecommons.org/ns#"
        xmlnsrdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlnssvg="http://www.w3.org/2000/svg"
        xmlns="http://www.w3.org/2000/svg"
        xmlnssodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlnsinkscape="http://www.inkscape.org/namespaces/inkscape"
        width={w}
        height={h}
        viewBox="0 0 16.933333 16.933334"
        version="1.1"
        id="svg8"
        inkscapeversion="0.92.2 5c3e80d, 2017-08-06"
        sodipodidocname="charger.svg"
      >
        <defs id="defs2">
          <linearGradient id="linearGradient12297" osbpaint="solid">
            <stop
              style={{ stopColor: '#000000', stopOpacity: 1 }}
              offset="0"
              id="stop12295"
            />
          </linearGradient>
        </defs>
        <sodipodiNamedview
          id="base"
          pagecolor="#ffffff"
          bordercolor="#666666"
          borderopacity="1.0"
          inkscapepageopacity="0.0"
          inkscapepageshadow="2"
          inkscapezoom="14.414829"
          inkscapecx="32.044152"
          inkscapecy="29.171318"
          inkscapedocument-units="mm"
          inkscapecurrent-layer="layer1"
          showgrid="false"
          units="px"
          inkscapeshowpageshadow="false"
          inkscapewindow-width="3840"
          inkscapewindow-height="2099"
          inkscapewindow-x="0"
          inkscapewindow-y="0"
          inkscapewindow-maximized="1"
        />
        <metadata id="metadata5">
          <rdfrDF>
            <ccWork rdfabout="">
              <dcFormat>image/svg+xml</dcFormat>
              <dcType rdfresource="http://purl.org/dc/dcmitype/StillImage" />
              <dcTitle></dcTitle>
            </ccWork>
          </rdfrDF>
        </metadata>
        <g
          inkscapelabel="Layer 1"
          inkscapegroupmode="layer"
          id="layer1"
          transform="translate(0,-280.06665)"
        >
          <path
            style={{
              opacity: 0.5,
              fill: rgb,
              fillOpacity: 1,
              stroke: 'none',
              strokeWidth: 0.46609831,
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeMiterlimit: 4,
              strokeDasharray: 'none',
              strokeDashoffset: 0,
              strokeOpacity: 1,
              paintOrder: 'normal'
            }}
            id="SymbolBackground"
            sodipoditype="arc"
            sodipodicx="8.4436836"
            sodipodicy="288.53629"
            sodipodirx="8.4788866"
            sodipodiry="8.4704943"
            sodipodistart="4.7142216"
            sodipodiend="4.7090204"
            d="m 8.4592222,280.06581 a 8.4788866,8.4704943 0 0 1 8.4633468,8.47498 8.4788866,8.4704943 0 0 1 -8.4723738,8.46599 8.4788866,8.4704943 0 0 1 -8.48538004,-8.45298 8.4788866,8.4704943 0 0 1 8.45030674,-8.48796"
            sodipodiopen="true"
          />
          {l3 && (
            <path
              style={{
                opacity: 1,
                fill: 'none',
                fillOpacity: 1,
                stroke: '#16162d',
                strokeWidth: 1.11849868,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeMiterlimit: 4,
                strokeDasharray: 'none',
                strokeDashoffset: 0,
                strokeOpacity: 1,
                paintOrder: 'normal'
              }}
              id="L3Phase"
              sodipoditype="arc"
              sodipodicx="9.1479883"
              sodipodicy="289.18427"
              sodipodirx="7.232008"
              sodipodiry="7.2863436"
              sodipodistart="0.011128743"
              sodipodiend="1.5133366"
              sodipodiopen="true"
              d="m 16.379548,289.26535 a 7.232008,7.2863436 0 0 1 -6.8162391,7.19323"
            />
          )}
          {l1 && (
            <path
              style={{
                opacity: 1,
                fill: 'none',
                fillOpacity: 1,
                stroke: '#16162d',
                strokeWidth: 1.11849868,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeMiterlimit: 4,
                strokeDasharray: 'none',
                strokeDashoffset: 0,
                strokeOpacity: 1,
                paintOrder: 'normal'
              }}
              id="L1Phase"
              sodipoditype="arc"
              sodipodicx="-7.8104353"
              sodipodicy="-287.91724"
              sodipodirx="7.232008"
              sodipodiry="7.2863436"
              sodipodistart="0.011128743"
              sodipodiend="1.5133366"
              sodipodiopen="true"
              d="m -0.57887515,-287.83615 a 7.232008,7.2863436 0 0 1 -6.81623955,7.19323"
              transform="scale(-1)"
            />
          )}
          {l2 && (
            <path
              style={{
                opacity: 1,
                fill: 'none',
                fillOpacity: 1,
                stroke: '#16162d',
                strokeWidth: 1.11849868,
                strokeLinecap: 'round',
                strokeLinejoin: 'round',
                strokeMiterlimit: 4,
                strokeDasharray: 'none',
                strokeDashoffset: 0,
                strokeOpacity: 1,
                paintOrder: 'normal'
              }}
              id="L2Phase"
              sodipoditype="arc"
              sodipodicx="289.21017"
              sodipodicy="-7.8266549"
              sodipodirx="7.232008"
              sodipodiry="7.2863436"
              sodipodistart="0.011128743"
              sodipodiend="1.5133366"
              sodipodiopen="true"
              d="m 296.44173,-7.7455687 a 7.232008,7.2863436 0 0 1 -6.81623,7.1932323"
              transform="rotate(90)"
            />
          )}
          {lance && (
            <g id="LanceG2120" inkscapelabel="#Lance">
              <g id="g12077">
                <path
                  style={{
                    fill: 'none',
                    stroke: '#000000',
                    strokeWidth: 1.11800003,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'bevel',
                    strokeMiterlimit: 4,
                    strokeDasharray: 'none',
                    strokeOpacity: 1
                  }}
                  d="m 16.379946,287.55973 -2.201321,-2.2472"
                  id="path12027"
                  inkscapeconnector-curvature="0"
                />
                <path
                  style={{
                    opacity: 1,
                    fill: 'none',
                    fillOpacity: 1,
                    stroke: '#16162d',
                    strokeWidth: 1.11800003,
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeMiterlimit: 4,
                    strokeDasharray: 'none',
                    strokeDashoffset: 0,
                    strokeOpacity: 1,
                    paintOrder: 'normal'
                  }}
                  id="path12068"
                  sodipoditype="arc"
                  sodipodicx="208.83733"
                  sodipodicy="191.67001"
                  sodipodirx="2.784307"
                  sodipodiry="2.0366266"
                  sodipodistart="4.7333047"
                  sodipodiend="1.5792799"
                  d="m 208.89556,189.63383 a 2.784307,2.0366266 0 0 1 2.72577,2.06612 2.784307,2.0366266 0 0 1 -2.80762,2.00662 l 0.0236,-2.03656 z"
                  transform="rotate(45)"
                />
              </g>
              <path
                inkscapeconnector-curvature="0"
                id="path12079"
                d="m 11.622773,283.57775 -1.558226,-1.55822"
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 1.11800003,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'miter',
                  strokeMiterlimit: 4,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
                }}
              />
              <path
                inkscapeconnector-curvature="0"
                id="path12079-1"
                d="m 12.732827,282.55027 -1.558226,-1.55822"
                style={{
                  fill: 'none',
                  stroke: '#000000',
                  strokeWidth: 1.11800003,
                  strokeLinecap: 'round',
                  strokeLinejoin: 'miter',
                  strokeMiterlimit: 4,
                  strokeDasharray: 'none',
                  strokeOpacity: 1
                }}
              />
            </g>
          )}
          {car && (
            <g
              id="CarSymbol"
              transform="matrix(0.0770268,0,0,0.06592897,3.8465004,285.18353)"
            >
              <path
                id="path12275"
                d="m 117.95,42.04 v 61.22 H 103.64 V 93.8 h -84.4 v 9.46 H 4.93 V 42.04 H 0 V 32.63 H 12.04 L 18.75,11.75 C 20.73,5.59 24.03,0 30.49,0 h 64.39 c 6.46,0 10.18,5.48 11.74,11.74 l 5.19,20.88 h 11.06 v 9.41 h -4.92 z M 40.01,74.91 h 42.27 v 9.97 H 40.01 Z M 9.72,51.69 c 10.77,0.34 17.36,4.85 19.05,14.26 H 9.72 Z m 102.08,0 C 101.03,52.03 94.44,56.54 92.75,65.95 H 111.8 Z M 17.18,32.62 H 105.7 L 101.91,15.11 C 100.87,10.31 97.88,6.16 92.96,6.16 H 31.74 c -4.92,0 -7.44,4.26 -8.95,8.95 z"
                className="st0"
                inkscapeconnector-curvature="0"
                style={{
                  clipRule: 'evenodd',
                  fillRule: 'evenodd'
                }}
              />
            </g>
          )}
          <text
            xmlSpace="preserve"
            style={{
              fontStyle: 'normal',
              fontWeight: 'normal',
              fontSize: '4.58706141px',
              lineHeight: 1.25,
              fontFamily: 'sans-serif',
              letterSpacing: '0px',
              wordSpacing: '0px',
              fill: '#000000',
              fillOpacity: 1,
              stroke: 'none',
              strokeWidth: 0.08967653
            }}
            x="5.6909237"
            y="294.05423"
            id="ChargeStationID"
            transform="scale(0.99700004,1.003009)"
          >
            <tspan
              sodipodirole="line"
              id="tspan13735"
              x="5.6909237"
              y="294.05423"
              style={{
                strokeWidth: 0.08967653
              }}
            >
              {cpId}
            </tspan>
          </text>
        </g>
        <style
          id="style12273"
          type="text/css"
        >{`.st0{fill-rule:evenodd;clip-rule:evenodd;}`}</style>
      </svg>
    </React.Fragment>
  );
};
